import styled from 'styled-components';
import { mediaQueries } from '../shared/config'; // Ensure this file contains your media query breakpoints
import ArticleCard from './ArticleCard';
import React from 'react';

const Container = styled.div`
  margin-left: auto;
  position: relative;
  height: auto;
  margin-top: 0em;
`;

const Grid = styled.div`
  display: grid;
  row-gap: 5em;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  align-items: center;
  flex-direction: column;
  
  ${mediaQueries.mobile} {
    grid-template-columns: repeat(1, 1fr);
    margin: auto;
    align-items: center;
    column-gap: 2em;
    row-gap: 3em;
    padding: 2em;
  }
`;

const BoxEmpty = styled.div`
  width: 67.22vh;
  height: 37.9vh;
  position: relative;
`;

const ContainerLast = styled.div`
  margin-left: 30%;
  margin-top: 10em;
  width: 50%;
  
  ${mediaQueries.mobile} {
    margin-left: auto;
    width: 100%;
  }
`;

export default function ArticleGrid(props) {
  console.log(props)
  const last_article = props.props[props.props.length - 2];
  const blurb2 = props.props[props.props.length - 1];
  props.props.pop();
  props.props.pop();
  const column_articles = props.props;

  return (
    <Container>
      <Grid>
        {column_articles && column_articles.map((item, index) => (
          <React.Fragment key={item.article_url}>

            { index !== 10 ? (index % 2 === 0 ? (
              <>
                <BoxEmpty />
                <ArticleCard
                  article_title={item.article_title}
                  article_url={item.article_url}
                  article_byline={item.article_byline}
                  article_image={item.article_image}
                  ten="false"
                />
              </>
            ) : (
              <>
                <ArticleCard
                  article_title={item.article_title}
                  article_url={item.article_url}
                  article_byline={item.article_byline}
                  article_image={item.article_image}
                  ten="false"
                />
                <BoxEmpty />
              </>
            )) : 

            //card that needs to be resized (10th one)
            <>
            <BoxEmpty />
            <ArticleCard
              article_title={item.article_title}
              article_url={item.article_url}  
              article_byline={item.article_byline}
              article_image={item.article_image}
              ten="true"
            />
          </>

          /* LAST CARD */ } 
            
          </React.Fragment>
        ))}
      </Grid>
      <ContainerLast>
        <ArticleCard
          article_title={last_article.article_title}
          article_url={last_article.article_url}
          article_byline={last_article.article_byline}
          article_image={last_article.article_image}
          ten="false"
        />
      </ContainerLast>

      <ContainerLast>
        <ArticleCard
          article_title={blurb2.article_title}
          article_url={blurb2.article_url}
          article_byline={blurb2.article_byline}
          article_image={blurb2.article_image}
          ten="false"
        />
      </ContainerLast>
      
    </Container>
    
  );
}
